// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1nCVn","col":"styles_col__Iws7c","fulfillmentStatus":"styles_fulfillmentStatus__3V-xi","emailCol":"styles_emailCol__428NI"};